import React, { useEffect, useState } from 'react';
import DGTH_voyage from '../components/DGTH_voyage';
import DGTH_voyage_double from '../components/DGTH_voyage_double';



export default function DataGridTopHook({ entity, data, setData, searchObj, setSearchObj, total }) {

    useEffect(() => {

    }, []);


    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch(entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'gyv_voyage': return (
                            <DGTH_voyage searchObj={searchObj} setSearchObj={setSearchObj} total={total} />
                        );
                        case 'gyv_voyage_double': return (
                            <DGTH_voyage_double searchObj={searchObj} setSearchObj={setSearchObj} total={total} />
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};